import React, { useEffect, useState } from "react";
import { injectIntl } from 'react-intl';
import { CSSTransition } from 'react-transition-group';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown, faCaretUp, faTrash } from '@fortawesome/free-solid-svg-icons';
import * as aTypes from 'Flow2/components/AdvancedBox/AdvancedConfig/AdvancedTypes';
import './Dropdown.scss';

function Dropdown(props) {
    const [current, setCurrent] = useState({});
    const [data, setData] = useState(props.data);
    const [isOpen, setIsOpen] = useState(false);

    function onDDItemClick(item) {
        props.onDDClick(item);
        setTimeout(() => setCurrent(item), 100);
    }

    function onDDItemTrashClick(item) {
        props.onDDTrashClick(item);
    }

    useEffect(() => {
        if (props.data && props.data.length > 0) {
            setData(props.data);
            if (props.current) {
                if (typeof props.current == 'string') {
                    let found = props.data.find(item => item.value === props.current
                        || item.name === props.current);
                    if (found) setCurrent(found);
                } else {
                    setCurrent(props.current);
                }
            }
            else setCurrent(props.data[0]);
        }
    }, [props.data, props.current])

    return (
        <div className="uidropdown-box">
            <div
                className={isOpen ? "dropdown active" : "dropdown"}
                onClick={() => {
                    if (data && data.length > 0) setIsOpen(!isOpen)
                }}>
                <div className={`dropdown-top ${props.isClassic ? 'classic-top' : ''}`}>
                    <div>
                        {/*(current && current.intl) ? props.intl.formatMessage({ id: current.intl }) : current.value*/}
                        {
                            // MOFIFIED BY NICK
                            (current && current.intl) ? props.intl.formatMessage({ id: current.intl, defaultMessage: current.value }) : current.value
                        }
                    </div>
                    <FontAwesomeIcon icon={isOpen ? faCaretUp : faCaretDown} />
                </div>
                <CSSTransition in={isOpen} timeout={300} classNames="dropdown-animation"
                    unmountOnExit onEnter={() => setIsOpen(true)} onExited={() => setIsOpen(false)}>
                    <div className="dropdown-box">
                        <ul className={`${props.isClassic ? 'classic-ui' : ''}`}>
                            {data && data.map((item, i) => (
                                <li className="dropdown-li" key={`dropdownMenuItem${i}`}>
                                    <a className="data-link" onClick={onDDItemClick.bind(null, item)}>
                                        {/*item.intl ? props.intl.formatMessage({ id: item.intl }) : item.value*/}
                                        {
                                            // MOFIFIED BY NICK
                                            item.intl ? props.intl.formatMessage({ id: item.intl, defaultMessage: item.value }) : item.value
                                        }
                                    </a>
                                    {(props.isDeleted && item.value !== aTypes.DUMMY_X) && (
                                        <span onClick={onDDItemTrashClick.bind(null, item)} className="dropdown-icon">
                                            <FontAwesomeIcon icon={faTrash} />
                                        </span>
                                    )}
                                </li>
                            ))}
                        </ul>
                    </div>
                </CSSTransition>
            </div>
        </div>
    )
}

export default injectIntl(Dropdown);
